var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{staticClass:"alert text-center",class:_vm.type,staticStyle:{"position":"fixed","top":"55px","z-index":"9999","left":"0px","width":"100%"}},[_vm._v("\n    "+_vm._s(_vm.msg)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }